import "core-js/modules/es.array.every";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.object.values";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getStationOilDiscountCounter } from '@/api/bairun/financialCenter';
import moment from 'moment';
import NP from 'number-precision';
import dateUtils from '@/utils/dateUtil';
export default {
  name: 'FinancialPlatformDiffPrice',
  data: function data() {
    var _this = this;

    return {
      datePickerValue: [(dateUtils.todayTimestamp() - 7 * 24 * 60 * 60) * 1000, (dateUtils.todayTimestamp() - 24 * 60 * 60) * 1000],
      downloadLoading: false,
      selectedArea: '全部',
      filterMapping: [{
        text: '佛山',
        value: '佛山'
      }, {
        text: '粤西',
        value: '粤西'
      }, {
        text: '外省',
        value: '外省'
      }],
      borderFix: ['合计/L', '合/L'],
      cellColClassFix: ['monthDiffPrice', 'monthDiffPrice0', 'monthDiffPrice92', 'monthDiffPrice95'],
      stationDailyPlatformDiscountData: [],
      tempGroupData: {},
      sheetUnLoadCount: 1,
      excelSheets: [{
        tableId: 'stationDailyPlatformDiscountData',
        name: '平台优惠价差报表',
        tableRows: 2
      }],
      selectedStation: {
        'ID': 0,
        'stationName': '',
        'statTag': '选择站点',
        'statAbbr': '',
        'appId': 'aaa'
      },
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  created: function created() {},
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs['stationDailyPlatformDiscountData'].doLayout(); // console.log('refsUpdate')

    });
  },
  methods: {
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
          column = _ref.column;

      if (this.borderFix.includes(column.label)) {
        return 'border-right:1px solid #000000';
      }

      if (this.cellColClassFix.includes(column.property)) {
        return 'background: #ffe9cf';
      }
    },
    getSummaries: function getSummaries(param) {
      var columns = param.columns,
          data = param.data;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }

        var values = data.map(function (item) {
          return Number(item[column.property]);
        });

        if (!values.every(function (value) {
          return isNaN(value);
        })) {
          sums[index] = values.reduce(function (prev, curr) {
            var value = Number(curr);

            if (!isNaN(value)) {
              return NP.plus(prev, curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = NP.round(sums[index], 2);
        } else {
          sums[index] = 'N/A';
        }
      });
      sums[4] = sums[1] > 0 ? NP.round(NP.divide(sums[3], sums[1]), 2) : '-';
      sums[8] = sums[5] > 0 ? NP.round(NP.divide(sums[7], sums[5]), 2) : '-';
      sums[12] = sums[9] > 0 ? NP.round(NP.divide(sums[11], sums[9]), 2) : '-';
      sums[17] = sums[14] > 0 ? NP.round(NP.divide(sums[16], sums[14]), 2) : '-';
      return sums;
    },
    loadData: function loadData() {
      var _this3 = this;

      if (this.downloadLoading) {
        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择具体的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      var descriptorData = {
        descriptors: [{
          type: 'ocosotpc',
          operator: 'dateOCOSOTPC',
          t: 555,
          name: 'StationPlatformDiscountCounter',
          start: this.datePickerValue[0] / 1000,
          end: this.datePickerValue[1] / 1000,
          search: (this.selectedStation.ID > 10000 ? this.selectedStation.ID : '').toString()
        }]
      };
      getStationOilDiscountCounter(descriptorData).then(function (response) {
        _this3.stationDailyPlatformDiscountData = Object.values(response.data).sort(function (a, b) {
          var orders = [10006, 10003, 10011, 10013, 10010, 10014, 10001, 10012, 10002, 10005, 10004, 10009, 10008, 10015]; // // console.log('sort orders', orders.indexOf(a.sellerId), orders.indexOf(b.sellerId))

          return orders.indexOf(a.sellerId) - orders.indexOf(b.sellerId);
        }); // console.log('this.stationDailyPlatformDiscountData', this.stationDailyPlatformDiscountData)

        _this3.downloadLoading = false;
        _this3.sheetUnLoadCount = 0;

        _this3.$refs['stationDailyPlatformDiscountData'].doLayout();
      }).catch(function () {
        _this3.downloadLoading = false;
      });
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this4 = this;

      if (this.sheetUnLoadCount > 0) {
        _Message({
          message: '请查询核对过后进行下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.selectedStation.ID === 0) {
        _Message({
          message: '请选择具体的站点',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (this.stationDailyPlatformDiscountData.length === 0) {
        _Message({
          message: '无有效数据，请查询后下载',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, moment(_this4.datePickerValue[0]).format('YYYY年MM月DD日') + ' ~ ' + moment(_this4.datePickerValue[1]).format('YYYY年MM月DD日') + excelName);
        _this4.downloadLoading = false;
      }).catch(function () {
        _this4.downloadLoading = false;
      });
    }
  }
};